import React from "react";
import styles from "./ArrowButton.module.css";
import clsx from "clsx";
import AssetsPack from "../../../../util/AssetsPack";

interface ArrowButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  text?: string;
}

const ArrowButton: React.FC<ArrowButtonProps> = ({ text = "Send", ...buttonProps }) => {
  return (
    <button
      {...buttonProps}
      className={clsx(
        styles["jap-button"],
        styles["jap-btn-send"],
        buttonProps.className
      )}
    >
      <p>{text}</p> <img src={AssetsPack.icons.ICON_ARROW_RIGHT.default} alt="" />
    </button>
  );
};

export default ArrowButton;
